import scatteredSpiderMarkdown from './blog/why-scattered-spider-attacks-work-so-well.md?raw';
import deepfakeModelMarkdown from './blog/deepfake-model.md?raw';
import neilAvatar from './assets/neil.jpg';
import xiangAvatar from './assets/xiang.png';

export interface BlogPost {
  title: string;
  slug: string;
  date: string;
  category: string;
  description: string;
  author: string;
  avatar: string;
  markdown?: string;
  content?: string;
}

export const posts: BlogPost[] = [
  {
    title: "Training the world's best audio deepfake detector",
    slug: "deepfake-model",
    date: "Jul 23",
    category: "AI",
    description: "Learnings from training a state-of-the-art model for deepfake detection.",
    author: "Xiang Li and Neil Patil",
    avatar: xiangAvatar,
    markdown: deepfakeModelMarkdown,
  },
  {
    title: "Defending against Scattered Spider",
    slug: "scattered-spider",
    date: "Jun 24",
    category: "Security",
    description: "A deep dive into Scattered Spider’s social engineering attacks, their playbook, and how to defend against them.",
    author: "Neil Patil",
    avatar: neilAvatar,
    markdown: scatteredSpiderMarkdown,
  }
]; 